"use client"

import React from "react";
import {useTranslations} from "use-intl";

import {Container} from "@mui/material";

export default function Credits() {

  const t = useTranslations('Credits')
  return (
    <Container maxWidth="md" sx={{mt: 2}}>
      <div style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{__html: t.raw("page")}}></div>
    </Container>
  )
}
